export enum VehicleFilterType {
    Vehicle = 0,
    VehicleMake = 1,
    VehicleModel = 2,
    VehicleYear = 3,
    CalibrationType = 4,
}
